import { Component, OnInit } from '@angular/core';
import { BaseViewComponent } from '@app/views/base-view-component';

@Component({
  selector: 'app-managed-projects',
  templateUrl: './managed-projects.component.html',
  styleUrls: ['./managed-projects.component.scss']
})
export class ManagedProjectsComponent implements OnInit {

  ngOnInit() {
  }

}
